import React, { useCallback, useEffect, useMemo, useState } from "react";
import SnackbarUtils from "../../../../../libs/SnackbarUtils";
import {
  serviceExitGroup,
  serviceGetGroupDetail,
} from "../../../../../services/Chat.service";

function useGroupDetailHook({
  groupId,
  handleUpdateGroup,
  handleClosepopOver,
}) {
  const [exitDialog, setExitDialog] = useState(false);
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [empId, setEmpId] = useState(null);
  useEffect(() => {
    if (groupId) {
      setIsLoading(true);
      const req = serviceGetGroupDetail({ id: groupId });
      req.then((res) => {
        if (!res?.error) {
          const resData = res?.data;
          setData(resData);
        }
        setIsLoading(false);
      });
    }
  }, [groupId]);

  const toggleExitDialog = useCallback((emp) => {
    setExitDialog((prev) => !prev);
    setEmpId(emp ? emp : null);
  }, []);
  const handleExit = useCallback(() => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      serviceExitGroup({ id: groupId, employee_id: empId?.id }).then((res) => {
        if (!res.error) {
          SnackbarUtils.success("User removed successfully");
          handleUpdateGroup();
          handleClosepopOver();
        } else {
          SnackbarUtils.error(res?.message);
        }
        setIsSubmitting(false);
      });
    }
  }, [setIsSubmitting, isSubmitting, empId, groupId]);

  const getCoAdminIDs = useMemo(() => {
    return data?.admin_ids?.filter((val) => val !== data?.created_by);
  }, [data]);

  return {
    handleExit,
    exitDialog,
    toggleExitDialog,
    data,
    isLoading,
    empId,
    getCoAdminIDs
  };
}

export default useGroupDetailHook;
